module.exports = __webpack_public_path__ + "static/media/AP_NES_Z2.f08d474f.png";